import { connect } from 'react-redux';
import { clickCategory } from '@/shared/components/photo_gallery/actions';
import Categories from '@/shared/components/photo_gallery/components/categories';

// Component へ渡すパラメータ値
const mapStateToProps = state => {
    return {
        categories: state.categories.categories,
        categoryId: state.categories.categoryId,
    };
};

// Component へ渡す Action
const mapDispatchToProps = dispatch => {
    return {
        clickCategory: (...args) => dispatch(clickCategory(...args)),
    };
};

// Component へパラメータを渡す
const connected = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Categories);

export default connected;
